import { gql } from 'graphql-request';
import { createQuery } from '@fivehealth/botero';

const GRAPHQL_DOCUMENT = gql`
  query cleoPatientChart(
    $patientFormUidIn: [String!]
    $parameterIn: [String!]
    $before: DateTime
    $after: DateTime
  ) {
    cleoPatientChart(
      patientFormUidIn: $patientFormUidIn
      parameterIn: $parameterIn
      before: $before
      after: $after
    ) {
      statistics {
        clinicalParameter {
          uid
          name
          unit
          groupName
          valueType
          sortOrder
          numberPrecision
        }
        count
        average
        values
        numbers
        min
        max
        submissionTimes
        variables
      }
    }
  }
`;

export default createQuery({
  gqlDocument: GRAPHQL_DOCUMENT,
  queryType: 'query',
  baseQueryKey: 'patientCharts',
  keepPreviousData: true,
  select: ({ cleoPatientChart }) => cleoPatientChart,
});
